// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2fbOe","approved":"Status_approved__327kq","rejected":"Status_rejected__u9kXw","expired":"Status_expired__ppAID","label":"Status_label__2e2oi"};